export const MAX_DEPTH = 9;
export const MAX_CHILDREN = 10;
export const DEFAULT_LANGUAGE = 'en';

export const fillerMock = Object.freeze({
  isFiller: true,
  screen: {
    id: -1,
    title: 'Return to Main Menu',
    regions: [{ type: 'menu_link', content: [] }],
  },
});

export const MENU_STYLE = Object.freeze({
  grid: 'grid',
  simpleGrid: 'simpleGrid',
  horizontal: 'horizontal',
  vertical: 'vertical',
});

export const DIRECTIONS = Object.freeze({
  up: 'up',
  down: 'down',
  left: 'left',
  right: 'right',
});

export const GRID_PAGE_SIZE = Object.freeze({
  [MENU_STYLE.grid]: Object.freeze({
    root: 8,
    default: 6,
  }),
  [MENU_STYLE.simpleGrid]: Object.freeze({
    root: 6,
    default: 6,
  }),
});

export const HORIZONTAL_PAGE_SIZE = 5;
